import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/unit-price", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/unit-price/csv", params);
};

const get = id => {
  return restApi.get(`/api/unit-price/${id}`);
};

const upsert = data => {
  return restApi.post("/api/unit-price/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/unit-price/${ids}`);
};

const unitPriceService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default unitPriceService;